export const eccentricity_item = (props) => {
    return {... {
            mass: 0,
            mpe: "0",
            position: 0,
            reading: null,
            addLoad: null,
            p: "0",
            error: "0",
            error_corr: "0",
            result: 'uncomplete'
        },
        ...props
    }
}

export const repeatability_item = (props) => {
    return {... {
            index: 0,
            mass: null,
            reading: null,
            addLoad: null,
            p: "0",
            result: 'uncomplete'
        },
        ...props
    }
}

export const zavorra_item = (props) => {
    return {... {
            index: 0,
            mass: null,
            reading: null,
            addLoad: null,
            p: "0",
            result: 'uncomplete'
        },
        ...props
    }
}

export const linearity_item = (props) => {
    return {... {
            index: 0,
            mass: "0",
            reading_up: null,
            reading_down: null,
            addLoad_up: null,
            addLoad_down: null,
            p_up: "0",
            p_down: "0",
            error_up: "0",
            error_down: "0",
            error_corr_up: "0",
            error_corr_down: "0",
            mpe: "0",
            result: 'uncomplete'
        },
        ...props
    }
}

export const linearity_item_new = (props) => {
    return {... {
            index: 0,
            mass: null,
            reading: null,
            addLoad: null,
            p: "0",
            error: "0",
            error_corr: "0",
            mpe: "0",
            result: 'uncomplete'
        },
        ...props
    }
}

export const linearity_zavorra_item = (props) => {
    //GSP 1.15 zavorra blocks
    return {... {
            index: 0,
            mass: null,
            sample_masses: null,
            zavorra: null,
            total: null,
            reading: null,
            addLoad: null,
            isMultiple: true,
            p: "0",
            error: "0",
            error_corr: "0",
            mpe: "0",
            result: 'uncomplete',
            button_class: 'full-width mt-1'
        },
        ...props
    }
}

export const iso_simple_item = (props) => {
    return {... {
            position: 0,
            mass: null,
            mpe: "0",
            reading: null,
            error: "0",
            result: 'uncomplete'
        },
        ...props
    }
}

export const linearity_comparison_item = (props) => {
    return {... {
            position: "0",
            reading: null,
            primaryReading: null,
            difference: "0",
            tolerance: "0",
            toleranceError: "0",
            result: 'uncomplete'
        },
        ...props
    }
}


export const liter_doser_item = (props) => {
    return {... {
            position: "0",
            reading: null,
            readingCalc: null,
            primaryReading: null,
            difference: "0",
            tolerance: "0",
            toleranceError: "0",
            result: 'uncomplete'
        },
        ...props
    }
}

export const humidity_probe_item = (props) => {
    return {... {
            position: "0",
            reading: null,
            primaryReading: null,
            difference: "0",
            tolerance: "0",
            result: 'uncomplete'
        },
        ...props
    }
}

export const cemento_item = (props) => {
    return{...{
        index: 0,
        mass: null,
        sample_masses: null,
        zavorra: null,
        total: '0',
        reading: null,
        error: "0",
        mpe: "0",
        result: 'uncomplete',
        tolerance: "0",
        toleranceError: "0"
        },
        ...props
    }
}

export const linearity_additives_item = (props) => {
    return {... {
            position: "0",
            mass: null,
            reading: null,
            difference: "0",
            tolerance: "0",
            toleranceError: "0",
            result: 'uncomplete'
        },
        ...props
    }
}

export const comparison_item = (props) => {
    return{...{
        rif: 0,
        mass: null,
        reading: null,
        error: "0",
        mpe: "0",
        result: 'uncomplete',
        }, 
        ...props
    }
}

export const vcheck_section_conf = (props) => {
    return {... {
            title: null,
            referral: null,
            hasRadioButtons: false,
            innerItems: [],
            // result: 'na',
            notes: null
        },
        ...props
    }
}

export const vcheck_tile = (props) => {
    return {... {
            name: null,
            referral: null,
            isSection: false,
            hasRadioButtons: false,
            sectionLength: 0,
            result: 'success',
            blocking: false,
            value_na: false,
            notes: null
        },
        ...props
    }
}

export const zero_accuracy_item = (props) => {
    return {... {
            mass: "0",
            reading: "0",
            addLoad: "0",
            p: "0",
            error: "0",
            mpe: "0",
            result: 'uncomplete'
        },
        ...props
    }
}

export const tare_item = (props) => {
    return {... {
            mass: "0",
            reading: null,
            addLoad: null,
            p: null,
            error: "0",
            mpe: "0",
            result: 'uncomplete'
        },
        ...props
    }
}

export const mobility_item = (props) => {
    return {... {
            divs: null,
            mass: "0",
            reading: null,
            addLoad: null,
            mpe: null,
            result: 'uncomplete'
        },
        ...props
    }
}

export const eccentricity_item_scie = (props) => {
    return {... {
            zero: "0",
            nom: null,
            reading: null,
            difference: "0",
            toleranceError: "0"
        },
        ...props
    }
}

export const repeatability_item_scie = (props) => {
    return {... {
            zero: "0",
            nom: null,
            reading: null,
            difference: "0",
            mean_difference: "0",
            square_mean_difference: "0",
            toleranceError: "0"

        },
        ...props
    }
}

export const linearity_item_scie = (props) => {
    return {... {
            nom: null,
            conv: "0",
            reading: null,
            weights: [],
            difference: "0",
            u_nom: "0",
            tolerance: "0",
            toleranceError: "0",
            u_conv: "0",
            result: "uncomplete"
        },
        ...props
    }
}

export const thermometer_phmeter_scie = (props) => {
    return {... {
            nom: null,
            primaryRead: null,
            conv: null,
            reading: null,
            difference: "0",
            uncertain: "0",
            tolerance: "0",
            toleranceError: "0",
            result: 'uncomplete'
        },
        ...props
    }
}

export const phmeter_termo_scie = (props) => {
    return {... {
            nom: null,
            primaryRead: null,
            resistance_theory: null,
            resistance: null,
            conv: null,
            reading: null,
            difference: "0",
            uncertain: "0",
            tolerance: "0",
            toleranceError: "0",
            result: 'uncomplete'
        },
        ...props
    }
}

export const pressuregauge_scie = (props) => {
    return {... {
            index: 0,
            nom: null,
            primaryReading: null,
            conv: null,
            reading: null,
            difference: "0",
            uncertain: "0",
            tolerance: "0",
            toleranceError: "0",
            result: 'uncomplete'
        },
        ...props
    }
}

export const nawi_eccentricity_lat = (props) => {
    return {... {
            zero_before: 0,
            reading: 0,
            zero_after: 0,
            difference: 0
        },
        ...props
    }
}

export const nawi_repeatability_lat = (props) => {
    return {... {
            zero_before: 0,
            reading: 0,
            zero_after: 0,
            mean: 0
        },
        ...props
    }
}